<template>
<div class="admin-main">
  <div class="page-content">
    <div class="left-menu">
      <left-menu-list></left-menu-list>
    </div>
    <div class="page-main">
      <div class="clearfix logo-and-personal">
        <div class="page-breadcrumb">
          <el-breadcrumb separator="/">
            <el-breadcrumb-item v-if="currentPath.meta" :to="{ path: '/home' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="!currentPath.meta">首页</el-breadcrumb-item>
            <el-breadcrumb-item v-if="currentPath.meta">{{currentPath.meta.title}}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="personal-details">
          <el-dropdown>
            <span class="el-dropdown-link">
              <span class="ellipsis" style="display:inline-block;height:16px;width:100px;cursor:pointer" title="这是一个账号这是一个账号">用户名：{{this.$store.getters.userInfo.userName}}</span><i style="vertical-align:middle" class="el-icon-arrow-down el-icon--right"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="info()">个人资料</el-dropdown-item>
              <el-dropdown-item @click.native="updatePwd()">修改密码</el-dropdown-item>
              <el-dropdown-item  @click.native="loginOut()" divided>退出登录</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
      </div>
      <div class="page-wrapper">
        <router-view></router-view>
      </div>
<!--      <div class="page-footer">-->
<!--        <p>Copyright©2017-2023武汉译满天下科技有限公司V2.6.2</p>-->
<!--      </div>-->
    </div>
  </div>
  <div class="logo-div">
    <img src="../assets/img/logo.png" />
  </div>
</div>
</template>

<script>
import LeftMenuList from '../components/leftMenu/index.vue'
export default {
  components:{
    LeftMenuList
  },

  data(){
    return {
      currentPath:{},
    }
  },
  mounted(){
    // this.routerArr = this.flattenArray(this.$router);
    console.log(this.$route,'this.routerArr')
    if (this.$route.path==='/home') {
      this.currentPath = {};
    } else {
      this.currentPath = this.$route;
    }
    let dataJson = {"code":200,"data":{"sevenRegNum":3,"sevenRegPcNum":0,"sevenRegWebNum":3,"sevenRegAppNum":0,"yesRegNum":0,"yesRegPcNum":0,"yesRegWebNum":0,"yesRegAppNum":0,"nowRegNum":0,"nowRegPcNum":0,"nowRegWebNum":0,"nowRegAppNum":0,"totalRegNum":225500,"totalRegPcNum":74548,"totalRegWebNum":106936,"totalRegAppNum":43313,"sevenACertSucessNum":0,"sevenACertFailNum":0,"yesACertSucessNum":0,"yesACertFailNum":0,"nowACertSucessNum":0,"nowACertFailNum":0,"totalACertSucessNum":20104,"totalACertFailNum":5167}}
  },
  methods:{
    // 数组扁平化
    flattenArray(arr) {
      return arr.reduce((result, item) => {
        if (item.children&&Array.isArray(item.children)) {
            result.push(...flattenArray(item)); // 递归数组
        } else {
            result.push(item);
        }
        return result;
      }, []);
    },
    info() {
      const jumpPath = '/backstage/myAccount/info';
      if(this.$route.path !== jumpPath){
        this.$router.push(jumpPath);
      }
    },
    updatePwd() {
      const jumpPath = '/backstage/myAccount/password';
      if(this.$route.path !== jumpPath){
        this.$router.push(jumpPath);
      }
    },
    loginOut() {
      this.$store.dispatch('user/loginOut')
    }
  },
  watch:{
    '$route':function(nVal,oVal){
      if (nVal.path==='/home') {
        this.currentPath = {};
      } else {
        this.currentPath = nVal;
      }
    }
  }
}
</script>

<style lang="less">
@import '../styles/main/index.less';
</style>



// WEBPACK FOOTER //
// src/views/main.vue